import React from 'react';

const Aboutme = () => {
    return (
        <div className='lg:mt-[-230px]'>
            <div className=" w-full lg:w-4/6 mx-auto mockup-window border bg-green-200">
                <div className="flex justify-center px-4 py-16 bg-green-100">
                <p className='text-xl'>I have some knowledge of modern website development. I learned some technologies like HTML, CSS, BOOTSTRAP, TAILWIND, MODERN JS or ES6, REACT JS, ROUTER, FIREBASE, etc...
                <br />
                <br />
                My dream is to be a software developer. I want to build large and modern websites and work with my project or services.
                <br />
                <br />
                I'm developing myself day by day to gather more knowledge about the website. I want to be a MERN stack developer and am also interested in learning Python and Django for the back-end....</p>
                </div>
            </div>
        </div>
    );
};

export default Aboutme;